import { cn } from '../../../lib/utils';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

export const CloseIcon = ({ onClick, className }: { onClick: () => void; className?: string }) => {
  return (
    <Button
      onClick={onClick}
      size="iconSm"
      className={cn('absolute top-0 right-0 z-10 m-2 p-1 duration-150', className)}
    >
      <Icon className="lucide--x" />
    </Button>
  );
};
